import Footer from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Footer/Footer"
import Hero from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Hero"
import MissionOverview from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Mission/MissionOverview"
import MissionTimeline from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Mission/MissionTimeline"
import NewsFeedGroup from "@/components/pages/MicroSite/Templates/FramebaseTemplate/NewsFeed/NewsFeedGroup"
import NewsFeedOverview from "@/components/pages/MicroSite/Templates/FramebaseTemplate/NewsFeed/NewsFeedOverview"
import Overview from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Overview"
import type { MicroSite } from "@/lib/api"

const FramebaseTemplate = ({data}:{data: MicroSite}) => {

  if(!data){
    return <div className="flex justify-center items-center h-screen text-center">No data available</div>
  };
  
  return (
    <div className="flex flex-col max-w-7xl mx-auto">
      <Hero data={data} />
    <Overview data={data} />
    <div className="grid gap-4 md:grid-cols-2 mt-12">
      <MissionOverview  data={data} />
      <MissionTimeline data={data}  />
    </div>
    <div className="flex flex-col gap-4 lg:gap-8 my-12">
      <NewsFeedOverview data={data}  />
      <NewsFeedGroup  data={data} />
    </div>

    <Footer  data={data} />
    </div>
  )
}

export default FramebaseTemplate